import { FC } from 'react';
// import { ContractItemType } from '../components/common/TableView';
import ContractDetail from '../components/contract/ContractDetail';
import CommonPage from '../components/page/CommonPage';
import { PageTitle } from '../components/common/PageTitle';

const ContractDetailPage : FC = () => {

    return (
        <CommonPage selectBtnIndex={1}>
            <PageTitle title="契約詳細" />
            <ContractDetail />
        </CommonPage>
    );
}

export default ContractDetailPage;